
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator'
import '@mein-oeamtc/lib-ui/lib/lib-ui.css'
import { namespace } from 'vuex-class'

const MembershipModule = namespace('Membership');
const TriplogModule = namespace('Triplog');
const SettingsModule = namespace('Settings');

@Component({
  name: 'App',
})
export default class App extends Vue {
  @Prop()
  private stage: string;

  @SettingsModule.Action('setStage')
  private setStage;

  @MembershipModule.Action('fetchMembershipInfo')
  private fetchMembershipInfo;

  @TriplogModule.Action('fetchVehicles')
  private fetchVehicles;

  @SettingsModule.Action('triggerGisFavoriteSynchronization')
  private triggerGisFavoriteSynchronization;

  async created() {
    this.setStage({ value: this.stage });

    const cms = window['cms']; // null when used in WebView

    if (cms && cms.identity) {
      cms.identity.registerSessionLoadedCallback(async (event) => {
        if (Object.keys(event).length === 0) {
          App.redirectToLogin();
        }
      });
    }

    const logoutButtons = document.body.getElementsByClassName('usernavigation__logout')
    for (let i = 0; i < logoutButtons.length; i++) {
      logoutButtons[i].addEventListener('click', App.redirectToLogin, false)
    }

    this.triggerGisFavoriteSynchronization();

    this.fetchVehicles()

    this.fetchMembershipInfo().catch(e => {
      if (e.response && e.response.status === 403) {
        const isTeaserWidget = this.$route.name === 'teaserWidget';
        this.$router.replace({ name: 'noMembershipPage', params: { teaserWidget: isTeaserWidget + '' } });
      } else {
        throw e;
      }
    })
  }

  private static redirectToLogin() {
    window.location.href = '/mein-oeamtc/login?redirect=' + window.location.href
  }
}
